import { useMemo } from "react";
import { useIntl } from "react-intl";

export const useFormattedMessage = (id: string, values?: any) => {
  const intl = useIntl();
  return useMemo(() => intl.formatMessage({ id }, values), [id]);
};
